/**
 * @typedef {Object} CustomLoaderProps
 * @property {Boolean} [fullWidth = false] To set the loader to full screen as overlay
 * @property {'small' | 'default' | 'large' | 'custom'} [size = default] To define the size of the loader, values can be 'small', 'default', 'large'
 * @property {string} [className] To add custom class to the main container of Loader
 * @property {ReactNode} [subHeading] text to show below Loader
 * @property {React.CSSProperties} [style]
 */

import React from 'react';

import cx from 'classnames';

import { LoaderIcon } from '@/assets/icons';

import styles from './Loader.module.scss';

/**
 * @description UI Component to display the spinner/loader. Underlying it is using the antd spinner component.
 *
 * @author  Pooja Waradkar <@pooja.waradkar>
 *
 * @reference https://ant.design/components/spin
 *
 * @param {CustomLoaderProps}  [props] https://ant.design/components/spin
 *
 * @returns {React.Element}
 */

const Loader = (props) => {
	const {
		className = '',
		fullWidth = false,
		size = 'default',
		subHeading = '',
		style,
		...otherProps
	} = props;

	return (
		<div
			style={style}
			className={cx(
				styles.loadingContainer,
				className,
				{
					[styles.fullWidth]: fullWidth,
				},
				subHeading && styles.withSubHeading,
			)}
			{...otherProps}
		>
			<LoaderIcon className={cx(styles.loader, styles[size])} />
			{<div className={styles.subHeading}>{subHeading}</div>}
		</div>
	);
};

export default Loader;
